import React from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useMyContext } from '../../../../context/MyContext';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import { z } from 'zod';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import ViewRateCalculator from '../../../../component/b2c/models/ViewRateCalculator';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, priceEstimator, getpincode, payment } from '../../../../config/config';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../../component/spinner/spinner';
import {
  Calculator,
  Star,
  Zap,
  Shield,
  Package,
  MapPin,
  Truck,
  ArrowRight,
} from 'lucide-react';


const rateCalculatorSchema = z.object({
  pickupPincode: z.string()
    .length(6, "Pickup P  incode must be exactly 6 digits")
    .regex(/^\d+$/, "Pickup pincode must be numeric"),
  dropPincode: z.string()
    .length(6, "Drop Pincode must be exactly 6 digits")
    .regex(/^\d+$/, "Drop Pincode  must be numeric"),
  // weight: z.string()
  //   .min(1, "weight is required")
  //   .regex(/^\d*\.?\d+$/, "weight must be a positive number and can be a float"),
  weight: z.preprocess(
    (val) => (val === '' ? undefined : Number(val)),
    z.number()
      .int("Weight must be a whole number")
      .min(50, "Weight must be at least 50 gm")
  ),
  length: z.string()
    .min(1, "Length is required")
    .regex(/^\d*\.?\d+$/, "Length must be a positive number and can be a float"),
  width: z.string()
    .min(1, "Width is required")
    .regex(/^\d*\.?\d+$/, "Width must be a positive number and can be a float"),
  height: z.string()
    .min(1, "Height is required")
    .regex(/^\d*\.?\d+$/, "Height must be a positive number and can be a float"),
  shipmentType: z.string().optional(),
  declaredValue: z
    .string()
    .optional()
    .refine(value => value === "" || (!isNaN(Number(value)) && Number(value) >= 0), {
      message: "Declared Value must be a non-negative number",
    }),
  prepaid: z.string().nonempty({ message: "Prepaid/COD is required" }),
  cod: z.string().optional(),
});

const RateCalculator = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [data, setData] = useState(null);
  const [prepaidValue, setPrepaidValue] = useState('');
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [pickupCity, setPickupCity] = useState('');
  const [dropCity, setDropCity] = useState('');


  const handlePrepaidChange = (e) => {
    setPrepaidValue(e.target.value);
  };

  const handlePincodeChange = (e, type) => {
    const { value } = e.target;
    const filteredValue = value.replace(/[^0-9]/g, '');
    setValue(type === 'pickup' ? 'pickupPincode' : 'dropPincode', filteredValue);
    if (filteredValue.length === 6) {
      clearErrors(type === 'pickup' ? 'pickupPincode' : 'dropPincode');
    }

    // Clear city whenever the pincode changes
    clearCity(type);

    if (filteredValue.length === 6) {
      fetchPincodeData(filteredValue, type)
    }
  };
  const handleNavagation = () => {
    navigate("/dashboard");
  }

  const handleViewClick = () => {
    setIsPopupOpen(true);
  };
  const handleClose = () => {
    setIsPopupOpen(false);
  };
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const { register, handleSubmit, formState: { errors }, reset, watch, setValue, clearErrors } = useForm({
    resolver: zodResolver(rateCalculatorSchema),
  });

  const onSubmit = async (data) => {
    setLoader(true);
    const requestBody = {
      from_pincode: data.pickupPincode,
      to_pincode: data.dropPincode,
      length: parseFloat(data.length),
      width: parseFloat(data.width),
      height: parseFloat(data.height),
      weight: parseFloat(data.weight),
      shipment_type: data.shipmentType,
      declared_value: data.declaredValue ? parseFloat(data.declaredValue) : "",
      payment_mode: data.prepaid,
      cod_amount: data.prepaid === 'cod' ? parseFloat(data.cod) : "",
    };

    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          token,
          cus_id: cusid,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      });

      if (response.data.status === "success") {
        // NOTE: form ka weight yahin response data ke saath attach kar diya
        // taaki popup ko pata chale ki kaunsa slab select karna hai
        setData({ ...response.data, requestWeight: parseFloat(data.weight) });
        reset();
        handleViewClick();
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };
  const clearCity = (type) => {
    if (type === 'pickup') {
      setPickupCity('');
    } else {
      setDropCity('');
    }
  }

  const pickupPincode = watch('pickupPincode');
  const dropPincode = watch('dropPincode');


  useEffect(() => {
    if (pickupPincode && pickupPincode.length === 6) {
      fetchPincodeData(pickupPincode, 'pickup');
    } else {
      clearCity('pickup');
    }
  }, [pickupPincode]);

  useEffect(() => {
    if (dropPincode && dropPincode.length === 6) {
      fetchPincodeData(dropPincode, 'drop');
    } else {
      clearCity('drop');
    }
  }, [dropPincode])


  const handleInputChange = (event) => {
    const { value, id } = event.target;

    if (['length', 'width', 'height'].includes(id)) {
      const filtered = value.replace(/[^0-9]/g, '');
      event.target.value = filtered;
    }
  };

  const fetchPincodeData = async (pincode, type) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city } = data.data[0];
        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        if (type === 'pickup') {
          setPickupCity(city);
        } else {
          setDropCity(city);
        }
      } else {
        clearCity(type);
        toast.error("Failed to fetch city data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
      <div className="z-10">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
            style={
              window.innerWidth < 768
                ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                : {}
            }>

            <Sidebar />
          </div>
        )}

        <div className="container bg-gray-100   flex flex-wrap gap-4 justify-between p-8 relative overflow-y-auto custom-scrollbar ">
          <div className=" w-full md:w-[45%] text-custom-gray bg-white font-sans  md:p-8 max-w-4xl  dark:text-white  dark:bg-darkmodeColor rounded-custom">
            <button 
              className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 bg-purple-700 text-white font-sans px-2 sm:px-4 py-2 sm:py-1 rounded h-[40px] w-[60%] sm:w-full flex items-center justify-center">
              Rate Calculator
            </button>
            <form className="space-y-6 font-semibold" onSubmit={handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 dark:text-white">
                <div>
                  <label htmlFor="pickupPincode" className="block text-sm mb-1">Pickup Pincode*</label>
                  <input
                    type="text"
                    maxLength="6"
                    id="pickupPincode"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.pickupPincode ? 'border-red-500' : ''}`}
                    {...register('pickupPincode')}
                    onChange={(e) => handlePincodeChange(e, 'pickup')}
                  />
                  {errors.pickupPincode ? (
                    <p className="text-red-500 text-sm mt-1">{errors.pickupPincode.message}</p>
                  ) : (
                    pickupCity && <p className="text-sm  text-customPurple mt-2">Pickup City: {pickupCity}</p>
                  )}
                </div>
                <div>
                  <label htmlFor="dropPincode" className="block text-sm mb-1">Drop Pincode*</label>
                  <input
                    type="text"
                    id="dropPincode"
                    maxLength="6"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.dropPincode ? 'border-red-500' : ''}`}
                    {...register('dropPincode')}
                    onChange={(e) => handlePincodeChange(e, 'drop')}
                  />
                  {errors.dropPincode ? (
                    <p className="text-red-500 text-sm mt-1">{errors.dropPincode.message}</p>
                  ) : (
                    dropCity && <p className="text-sm text-customPurple mt-2">Drop City: {dropCity}</p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 dark:text-white">
                <div>
                  <label className="block text-sm mb-1">Dimensions (in Cms)*</label>
                  <div className="grid grid-cols-3 gap-2">
                    <input
                      type="text"
                      id='length'
                      step="0.01"
                      className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.length ? 'border-red-500' : ''}`}
                      placeholder="L"
                      {...register('length')}
                      onChange={handleInputChange}
                    />
                    <input
                      type="text"
                      step="0.01"
                      id='width'
                      className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.width ? 'border-red-500' : ''}`}
                      placeholder="w"
                      {...register('width')}
                      onChange={handleInputChange}
                    />
                    <input
                      type="text"
                      id='height'
                      className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.height ? 'border-red-500' : ''}`}
                      placeholder="H"
                      step="0.01"
                      {...register('height')}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.length && <p className="text-red-500 text-sm mt-1">{errors.length.message}</p>}
                </div>
                <div>
                  <label htmlFor="weight" className="block text-sm mb-1">Weight (in Grms)*</label>
                  <input
                    id="weight"
                    type="number"
                    step="0.01"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.weight ? 'border-red-500' : ''}`}
                    {...register('weight')}
                  />
                  {errors.weight && <p className="text-red-500 text-sm mt-1">{errors.weight.message}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 dark:text-white">
                <div>
                  <label htmlFor="shipmentType" className="block text-sm mb-1">Shipment Type</label>
                  <select
                    id="shipmentType"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.shipmentType ? 'border-red-500' : ''}`}
                    {...register('shipmentType')}
                  >
                    <option value="">Select Shipment Type</option>
                    <option value="Forward">Forward</option>
                  </select>
                  {errors.shipmentType && <p className="text-red-500 text-sm mt-1">{errors.shipmentType.message}</p>}
                </div>
                <div>
                  <label htmlFor="declaredValue" className="block text-sm mb-1">Declared Value</label>
                  <input
                    type="text"
                    id="declaredValue"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.declaredValue ? 'border-red-500' : ''}`}
                    {...register('declaredValue')}
                  />
                  {errors.declaredValue && <p className="text-red-500 text-sm mt-1">{errors.declaredValue.message}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 dark:text-white">
                <div>
                  <label htmlFor="prepaid" className="block text-sm mb-1">Prepaid/COD*</label>
                  <select
                    id="prepaid"
                    className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.prepaid ? 'border-red-500' : ''}`}
                    {...register('prepaid')}
                    onChange={handlePrepaidChange}
                  >
                    <option value="">Select Prepaid/COD</option>
                    <option value="prepaid">Prepaid</option>
                    <option value="cod">COD</option>
                  </select>
                  {errors.prepaid && <p className="text-red-500 text-sm mt-1">{errors.prepaid.message}</p>}
                </div>
                {prepaidValue === 'cod' && (
                  <div>
                    <label htmlFor="cod" className="block text-sm mb-1">COD Amount*</label>
                    <input
                      id="cod"
                      type="text"
                      className={`w-full px-3 py-2 shadow-custom-light rounded-custom dark:shadow-custom-dark dark:text-white dark:bg-darkmodeColor ${errors.codAmount ? 'border-red-500' : ''}`}
                      {...register('cod')}
                    />
                    {errors.cod && <p className="text-red-500 text-sm mt-1">{errors.cod.message}</p>}
                  </div>
                )}
              </div>
              <div className="text-center">
                <button type="submit" className="bg-customPurple text-white px-6 py-2 rounded-md hover:bg-purple-700">
                  {loader ? <Spinner /> : "Submit"}
                </button>
              </div>
            </form>
          </div>
          <div className={`w-full lg:w-1/2 overflow-hidden hidden lg:block relative group`}>
            <div className={`absolute inset-0 bg-gradient-to-br ${isDarkMode ? 'from-indigo-900 to-purple-900' : 'from-indigo-100 to-purple-200'} opacity-80 rounded-xl transform transition-all group-hover:scale-105 duration-500`}></div>

            <div className="absolute inset-0 flex flex-col">
              {/* Decorative Elements */}
              <div className="absolute top-10 right-10">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-20">
                  <circle cx="40" cy="40" r="40" fill="white" />
                  <path d="M20 40H60M40 20V60" stroke={isDarkMode ? "#6366F1" : "#4F46E5"} strokeWidth="4" strokeLinecap="round" />
                </svg>
              </div>
              <div className="absolute bottom-10 left-10">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-20">
                  <rect width="60" height="60" rx="12" fill="white" />
                  <path d="M15 30H45M30 15V45" stroke={isDarkMode ? "#6366F1" : "#4F46E5"} strokeWidth="3" strokeLinecap="round" />
                </svg>
              </div>

              {/* Content Container */}
              <div className="flex-1 z-10 flex flex-col p-8">
                {/* Header */}
                <div className="mb-6">
                  <h2 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-indigo-900'}`}>
                    Shipping Made <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500">Simple</span>
                  </h2>
                  <div className="w-16 h-1 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full mt-3"></div>
                </div>

                {/* Image with Animated Overlay */}
                <div className="relative mx-auto w-full max-w-sm mb-8 perspective-1000">
                  <div className="relative z-10 transform transition-all duration-500 group-hover:scale-105 group-hover:rotate-1 shadow-2xl rounded-lg overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-tr from-indigo-500/20 to-purple-500/20 z-10 pointer-events-none"></div>
                    <img
                      src="/assets/images/ratecalculator.png"
                      alt="Rate Calculator"
                      className="w-full h-auto object-cover relative z-0"
                    />
                  </div>

                  {/* Floating elements */}
                  <div className="absolute -top-4 -right-4 w-12 h-12 rounded-full bg-gradient-to-br from-pink-500 to-purple-500 shadow-lg transform transition-all duration-500 group-hover:scale-110 group-hover:translate-x-1"></div>
                  <div className="absolute -bottom-4 -left-4 w-8 h-8 rounded-full bg-gradient-to-br from-indigo-500 to-blue-500 shadow-lg transform transition-all duration-500 group-hover:scale-110 group-hover:-translate-x-1"></div>
                </div>

                {/* Features List */}
                <div className="space-y-4 mt-auto">
                  <div className={`flex items-center p-3 rounded-lg transition-all duration-300 ${isDarkMode ? 'bg-indigo-900/50 hover:bg-indigo-800/70' : 'bg-white/70 hover:bg-white'} backdrop-blur-sm`}>
                    <div className={`flex-shrink-0 w-10 h-10 ${isDarkMode ? 'bg-indigo-600' : 'bg-indigo-500'} rounded-full flex items-center justify-center mr-4`}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Preferred by 10,000+ businesses</h3>
                      <p className={`text-sm ${isDarkMode ? 'text-indigo-200' : 'text-indigo-700'}`}>Join thousands of happy customers</p>
                    </div>
                  </div>

                  <div className={`flex items-center p-3 rounded-lg transition-all duration-300 ${isDarkMode ? 'bg-indigo-900/50 hover:bg-indigo-800/70' : 'bg-white/70 hover:bg-white'} backdrop-blur-sm`}>
                    <div className={`flex-shrink-0 w-10 h-10 ${isDarkMode ? 'bg-indigo-600' : 'bg-indigo-500'} rounded-full flex items-center justify-center mr-4`}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Lightning-fast rate calculation</h3>
                      <p className={`text-sm ${isDarkMode ? 'text-indigo-200' : 'text-indigo-700'}`}>Get quotes in less than 2 seconds</p>
                    </div>
                  </div>

                  <div className={`flex items-center p-3 rounded-lg transition-all duration-300 ${isDarkMode ? 'bg-indigo-900/50 hover:bg-indigo-800/70' : 'bg-white/70 hover:bg-white'} backdrop-blur-sm`}>
                    <div className={`flex-shrink-0 w-10 h-10 ${isDarkMode ? 'bg-indigo-600' : 'bg-indigo-500'} rounded-full flex items-center justify-center mr-4`}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div>
                      <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>100% accurate pricing</h3>
                      <p className={`text-sm ${isDarkMode ? 'text-indigo-200' : 'text-indigo-700'}`}>No hidden fees or surprise charges</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewRateCalculator isopen={isPopupOpen} onClose={handleClose} data={data} />
    </div>
  );
};

export default RateCalculator;